module.exports = __webpack_public_path__ + "img/P150T_weapon_154.5708c106.png";